module.exports = __webpack_public_path__ + "static/media/sign up - table.a7b0d971.jpg";